import { makeObservable, observable, action } from 'mobx';
import DocumentReloadRequests from 'Utils/Requests/DocumentReloadRequests';
import FiltersStore from 'Stores/DocumentReload/FiltersStore';
import AppStore from "Stores/AppStore";
import { ShowAlert } from 'Utils/CommonFunctions';

class DocumentReloadStore {
    recordsLoading;
    /** @type {DocumentReloadState} */
    reloadState;
    pageToSet;

    constructor() {
        makeObservable(this, {
            recordsLoading: observable,
            reloadState: observable,
        });
        this.ClearStore();
    }

    ClearStore = action(() => {
        this.recordsLoading = false;
        this.reloadState = {
            inProcess: false,
            lid: '',
            regNum: '',
            regDate: ''
        };
        this.pageToSet = 1;
    });

    SetState(state) {
        this.reloadState = state;
    }

    GetData = action((pageToSet) => {
        if (pageToSet)
            this.pageToSet = pageToSet;
        if (!this.pageToSet)
            this.pageToSet = 1;

        this.recordsLoading = true;
        let elementsPerPage = this.tableStore.paginationInfo.elementsPerPage;
        let start = (this.pageToSet - 1) * elementsPerPage;

        let filters = {
            ...FiltersStore.filters,
            start: start,
            length: elementsPerPage
        };

        DocumentReloadRequests.GetData(filters)
            .then((values) => {
                if (values.error) {
                    ShowAlert('error', "Ошибка поиска");
                    return;
                }

                if (!this.tableStore.HandlePagination(this.SetPageData, values.recordsFiltered, this.pageToSet, page => this.GetData(page)))
                    return;

                this.tableStore.data = values.data;
            })
            .finally(action(() => {
                this.recordsLoading = false;
            }));
    });

    ReloadDocument(item) {
        this.recordsLoading = true;

        DocumentReloadRequests.ReloadDocument(item)
            .then((values) => {
                this.SetState(values);
            })
            .finally(() => {
                this.recordsLoading = false;
            });
    }

    SetTableStore(store) {
        this.tableStore = store;
    }

    SetPageData(pageToSet) {
        window.history.pushState(null, "Перезагрузка документов", `${window.SmrLocation}/documentReload?page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'documentReload',
            params: {
                page: `${pageToSet}`
            }
        });
    }

    SetRegDateFilter(filterName, date) {
        this.filters.regDate[filterName] = date;
    };
}

export default new DocumentReloadStore();